import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { FlexCenter } from "../../../../constant/CustomeStyle";
import AddWarehouseType from "./AddWarehouseType";

const AddWarehouseTypeFormik = (props) => {
  const submit = (data, { resetForm }) => {
    console.log("create product: " + JSON.stringify(data));
  };

  const validationSchema = Yup.object({
    Name: Yup.string("Enter a name").required("Name is required"),
  });

  const values = {
    Name: "",
  };

  return (
    <div>
      <FlexCenter>
        <TopTitle />
      </FlexCenter>

      <Formik
        render={(props) => <AddWarehouseType {...props} />}
        initialValues={values}
        validationSchema={validationSchema}
        onSubmit={submit}
      />
    </div>
  );
};

const TopTitle = () => (
  <FlexCenter
    style={{
      width: 702,
      height: 55.15,
      color: "#FFF",
      background: "#333C4B",
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    Add Warehouse Type
  </FlexCenter>
);

export default AddWarehouseTypeFormik;
